<template>
    <div class="container mescroll-touch">
        <img src="../../assets/images/ccdsjiaotongtopnew.png" class="img" />
        <!-- <img src="../../assets/images/topguanggao.png" class="guanggaoimg" /> -->
        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/jiaotongicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">会议地点</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">上海虹桥宾馆（上海市长宁区延安西路2000号）</div>
                <!-- <div class="newtext">点击以下地图即可查询交通路线</div> -->
            </div>
            <img src="../../assets/images/ccdspos.png" alt="" class="posimg">
            <!-- <div class="mapview" @click="goapp(31.203989, 121.410082, '上海虹桥宾馆')">
                <el-amap class="amap-box" :vid="'amap-vue'" @init="handleMapInit" :zoom="zoom" :center="position">
                    <el-amap-marker :vid="'marker'" :position="position" :events="events" ref="map"></el-amap-marker>
                </el-amap>
            </div> -->
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/jiaotongicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">住宿信息</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name"><span class="perplebold">会议酒店线上预留：</span></div>
                <div class="name"><span class="perplebold">邮箱：</span>meetings@goldentuliprainbow.com</div>
                <div class="name"><span class="perplebold">联系人：</span>13671848288(微信同号)</div>
                <div class="name"><span class="perplebold">房价：</span>大床550含早，双床600含双早</div>
                <div class="name small">*房间预定截止时间为2025年8月31日，截止日之后根据酒店实际出租率给予房间或调整价格。预定将遵循先订先得的原则，现场不保证住宿房源</div>
            </div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/jiaotongicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">公共交通</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name"><span class="darkperplebold">3号线/4号线延安西路站约1km，步行约14分钟</span></div>
                <div class="name"><span class="darkperplebold">10号线伊犁路站约1km，步行约14分钟</span></div>
                <br />
                <div class="name">距离信息：</div>
                <div class="name">虹桥国际机场/虹桥火车站约10公里，驾车约30分钟</div>
                <div class="name">浦东国际机场约48公里，驾车约70分钟</div>
                <div class="name">上海火车站约9.2公里，驾车约33分钟</div>
                <div class="name">上海南站约8公里，驾车约24分钟</div>
            </div>
        </div>
        <floatback></floatback>
    </div>
</template>

<script>
import floatback from './floatback.vue';
import mixin from '../../common/mixin/mixins'
export default {
    name: 'ccdsjiaotong',
    data() {
        return {
            map: null,
            zoom: 17,
            position: [121.410082, 31.203989],
            events: {},
        }
    },
    mixins: [mixin],
    components: {
        floatback
    },
    created() {
        this.initccdsShare();
        document.title = "CCDS第四届中国皮肤外科大会";
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
.container {
    height: 100%;
    width: 100%;
    // background: rgb(228, 236, 255);
}

.img {
    display: block;
    width: 100%;
    margin-bottom: .2rem
}

.zuzhititleimg {
    display: block;
    width: 55%;
    margin: auto;
    margin-bottom: .2rem
}

.zuzhititleimg1 {
    display: block;
    width: 55%;
    margin: .5rem auto .2rem auto;
}

.guanggaoimg {
    display: block;
    width: 92%;
    margin: 0.5rem auto;
}

.modelline {
    border-bottom: 1px solid rgb(0, 53, 133);
    border-bottom-left-radius: 50rem;
}

.modeltitle {
    background: rgb(0, 53, 133);
    width: 37%;
    display: flex;
    flex-direction: row;
    padding: 0.1rem;
    border-radius: 30px 50px 0px 30px;
}

.modeltitle1 {
    background: rgb(0, 53, 133);
    width: 45%;
    display: flex;
    flex-direction: row;
    padding: 0.1rem;
    border-radius: 30px 50px 0px 30px;
}

.modeltitleimg {
    display: block;
    width: 15%;
    background: #fff;
    border-radius: 50rem;
    width: 0.5rem;
    height: 0.5rem;
    box-sizing: border-box;
    padding: 0.05rem 0.08rem;
}

.modeltitletext {
    margin-left: 0.2rem;
    color: #fff;
    font-weight: bold;
    // font-size: 16px;
}

.model {
    width: 92%;
    margin: auto;
    margin-top: 0.5rem;
}

.model1 {
    width: 92%;
    margin: auto;
    margin-top: 0.5rem;
    padding-bottom: 1rem;
}

.center {
    text-align: center;
}

.preple {
    color: rgb(0, 53, 133);
}

.neirong {
    margin-top: .3rem
}

.ziti {
    font-size: .37rem;
}

.neirong {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 95%;
    margin: auto;
    margin-top: 0.3rem;
}

.name {
    width: 100%;
    // text-align: center;
    font-size: .37rem;
    margin: 0.08rem 0;
    // margin: 0.1rem 0;
}

.name1 {
    width: 50%;
    text-align: right;
    font-size: .37rem;
    // margin: 0.1rem 0;
}

.perplebold {
    color: rgb(0, 53, 133);
    font-weight: bold;
}

.wait {
    text-align: center;
    color: rgb(0, 53, 133);
    font-weight: bold;
    font-size: .55rem;
    margin-top: 20%;
}

.mapview {
    width: 95%;
    margin: auto;
    height: 5.5rem;
    margin-top: 0.3rem;
}

.darkperplebold {
    color: rgb(0, 53, 133);
    // font-weight: bold;
}

.newtext {
    margin-top: 0.5rem;
    font-weight: bold;
}

.small {
    font-size: .3rem;
}

.posimg {
    width: 100%;
    margin-top: 0.5rem;
}
</style>